import { computed, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';

export class StoreService<T> {
  private state = signal({} as T);
  
  protected currentValue<K extends keyof T>(key: K): T[K] {
    return computed(() => this.state()[key])();
  }

  protected select<K extends keyof T>(key: K): Observable<T[K]> {
    return toObservable(computed(() => this.state()[key]));
  }

  protected selectWith<K>(mapFn: (state: T) => K): Observable<K> {
    return toObservable(this.state).pipe(
      map(mapFn),
      distinctUntilChanged()
    );
  }

  constructor() {
    this.state = signal({} as T);
  }

  protected set<K extends keyof T>(key: K, data: T[K]) {
    this.state.update((prev) => ({ ...prev, [key]: data }));
  }

  protected setState(partialState: Partial<T>) {
    this.state.update((prev) => ({ ...prev, ...partialState }));
  }
}